/**
 * @file Built in localization messages. If the amount of messages grows large, it might be a good
 *       idea to load them up from the server.
 */

export default {
  INDEX_CONTAINER: {
    TITLE: {
      en: 'Hello World!'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/resource.ts